
import { useEffect, useState } from 'react'
import Box from '@mui/system/Box'
import { useTheme } from '@mui/material/styles';
import useRemote from 'lib/useRemote';
import { useRecoilState } from 'recoil';
import { playedAudioAtom } from 'lib/globalState';

interface Props {
    children: React.ReactNode,
    bg?: string,
    style?: React.CSSProperties,
    syncNavCommand?: string,
    audioFile?: string,
    repeatSound?: boolean
}

export default function Page({ children, bg, style, syncNavCommand, audioFile, repeatSound }: Props) {
    const theme = useTheme();
    const { result: commandResult } = useRemote({ command: syncNavCommand });
    const [playedAudios, setPlayedAudios] = useRecoilState(playedAudioAtom)

    useEffect(() => {
        let audio: HTMLAudioElement | AudioBufferSourceNode

        const playAudio = (audioFile: string) => {

            try {
                // @ts-ignore
                const audioContext = new (window.AudioContext || window.webkitAudioContext)();

                navigator.mediaDevices
                    .getUserMedia({ audio: true })
                    .then(() => {
                        const source = audioContext.createBufferSource();
                        source.addEventListener('ended', () => {
                            source.stop();
                            audioContext.close();
                        });

                        const request = new XMLHttpRequest();

                        request.open('GET', audioFile, true);
                        request.responseType = 'arraybuffer';
                        request.onload = () => {
                            audioContext.decodeAudioData(
                                request.response,
                                (buffer) => {
                                    source.buffer = buffer;
                                    source.connect(audioContext.destination);
                                    audio = source
                                    source.start();
                                    console.log("started as stream")
                                },
                                (e) => {
                                    console.log('Error with decoding audio data' + e.message);
                                });
                        }

                        request.send();
                    })
                    .catch(reason => console.error(`Audio permissions denied: ${reason}`));
            } catch (e) {
                console.error(e);

                audio = new Audio(audioFile);
                audio.loop = false;
                audio.addEventListener("canplaythrough", event => {
                    // @ts-ignore
                    audio.play()
                })
            }


        }

        if (audioFile && !playedAudios[audioFile]) {
            if (!repeatSound) {
                setPlayedAudios(prev => ({ ...prev, [audioFile]: true }))
            }
            // document.addEventListener("visibilitychange", () => stopAudio(audio), false)
            playAudio(audioFile)
        }

        const stopAudio = (audio: HTMLAudioElement | AudioBufferSourceNode) => {
            if (audio) {
                try {

                    // @ts-ignore
                    audio.pause()
                    console.log("paused as file")
                }
                catch (e) {
                    try {
                        // @ts-ignore
                        audio.stop()
                        console.log("paused as stream")
                    } catch (e) {
                        alert(e)

                    }
                }
            }
        }

        return () => {
            stopAudio(audio)
            //document.removeEventListener("visibilitychange", () => stopAudio(audio), false)
        }
    }, []) // to observe


    return (
        <Box
            flex={1}
            style={{
                backgroundColor: bg || theme.palette.background.default,
                minHeight: '100vh',
                display: 'flex',
                ...style
            }}
        >
            {children}
        </Box>
    )
}